module.exports = __webpack_public_path__ + "img/operating-score.e3405df0.png";